import React from "react"
import { Link, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import SeoBlog from "../components/SeoBlog"
import { readingTime } from "reading-time-estimator"
import { convert } from "html-to-text"
import LayoutBlog from "../components/LayoutBlog"
import BlogCategoriesList from "../components/blog/BlogCategoriesList"

const BlogPost = ({ data: { previous, next, post } }) => {
  const featuredImage = {
    data: post.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData,
    alt: post.featuredImage?.node?.altText || ``,
  }
  const htmlContent = parse(post.content)
  const PlainText = convert(htmlContent, {
    wordwrap: 130,
  })
  const result = readingTime(PlainText, 10)
  return (
    <LayoutBlog>
      <SeoBlog title={post.seo.title} description={post.seo.metaDesc} />
      <div className="d-none">
        <pre>
          <code></code>
        </pre>
      </div>
      <div className="content bg blogs" id="mhkb">
        <section className="my-lg-14 my-8">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12">
                <article
                  className="blog-post"
                  itemScope
                  itemType="https://schema.org/Article"
                >
                  <div className="mb-5">
                    <h1 className="fw-bold text-center" itemProp="headline">
                      {parse(post.title)}
                    </h1>
                    <div className="d-flex justify-content-center text-muted mt-4">
                      <span className="me-2">
                        <small>{post.date}</small>
                      </span>
                      <span>
                        <small>
                          Read time:
                          <span className="fw-bold">{result.text}</span>
                        </small>
                      </span>
                    </div>
                  </div>
                  <div className="mb-8">
                    {/* if we have a featured image for this post let's display it */}
                    {featuredImage?.data && (
                      <GatsbyImage
                        image={featuredImage.data}
                        alt={featuredImage.alt}
                        style={{ marginBottom: 50 }}
                      />
                    )}
                  </div>

                  {!!post.content && (
                    <div className="mb-4" itemProp="articleBody">
                      {parse(post.content)}
                    </div>
                  )}
                  <hr />
                </article>

                <nav className="blog-post-nav">
                  <ul
                    style={{
                      display: `flex`,
                      flexWrap: `wrap`,
                      justifyContent: `space-between`,
                      listStyle: `none`,
                      padding: 0,
                    }}
                  >
                    <li>
                      {previous && (
                        <Link
                          to={previous.uri}
                          rel="prev"
                          title={parse(previous.title)}
                        >
                          ← {parse(previous.title)}
                        </Link>
                      )}
                    </li>

                    <li>
                      {next && (
                        <Link
                          to={next.uri}
                          rel="next"
                          title={parse(next.title)}
                        >
                          {parse(next.title)} →
                        </Link>
                      )}
                    </li>
                  </ul>
                </nav>
              </div>
             
                <BlogCategoriesList />

            
            </div>
          </div>
        </section>
      </div>
    </LayoutBlog>
  )
}

export default BlogPost

export const BlogPostQuery = graphql`
  query BlogPostById(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      date(formatString: "MMMM DD, YYYY")
      seo {
        title
        metaDesc
      }
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
      }
      tags {
        nodes {
          name
        }
      }
    }
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
    }
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`
